import { render, staticRenderFns } from "./OtherShippersFilter.vue?vue&type=template&id=308d8259&scoped=true"
import script from "./OtherShippersFilter.vue?vue&type=script&lang=js"
export * from "./OtherShippersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308d8259",
  null
  
)

export default component.exports